var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"oeamtc-panel"},[_c('div',{staticClass:"row align-center px-l py-m"},[_c('icon-notification-info',{staticClass:"icon",attrs:{"width":"16","height":"16","fill":"#f89926"}}),_c('p',{staticClass:"oeamtc-text ml-m"},[_vm._v(_vm._s(_vm.text))]),_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }